import { useNavigate } from 'react-router-dom';
import React from 'react'
import { Button, Container, Row, Col } from 'react-bootstrap';
import Meta from '../../../components/Meta';

const HowToRental = () => {
    const navigate = useNavigate();
  return (
    <>
    <Meta>
        title='購入・レンタル方法について | ふるぷら'
        description='レンタル・購入の手順について説明するページです。'
        keywords={['ふるぷら', '古着', 'レンタル', '購入']}
    </Meta>
    <Container className="my-5">
        <Row className='justify-content-center'>
            <Col xs={12} md={8} lg={5}>
                <h1 className="fs-3 mb-4 text-center">購入・レンタル方法について</h1>
                <section className='howtorentaltop-rental'>
                    <h2 className="fs-5 fw-bold">通常の購入手順について</h2>
                    <p>
                        1．商品を選択する。<br />
                        2．商品ページの【オーダー】＞＞ 購入を選択する<br />
                        3. 受取方法を選択する。<br />
                        　 デフォルトの設定では、『店舗で受け取る』にチェックがついています。<br />
                        　 郵送での受取を希望する場合は、こちらのチェックを外してください。<br />
                        　※郵送の場合、送料が880円かかります。<br />
                        4．住所の登録・決済方法の登録を行う。<br />
                        5．決済を完了する。<br />
                        6．ご注文確認メールが登録メールアドレスに届く<br />
                        7．店舗または郵送で商品を受け取る。<br />
                    </p>
                    <h2 className="fs-5 fw-bold">レンタル中の購入、またはレンタル期間延長の手順について</h2>
                        <p>
                            1．サイト最上部に固定されているサイドバーから、👤＜＜注文履歴をクリックする。<br />
                            2．【返却期限が近い商品】の中から、購入したい商品、またはレンタル期間を延長したい商品の【確認する】をクリックする<br />
                            3.【10％オフで購入】【レンタル期間を延長する】を選択する。<br />
                            4．住所の登録・決済方法の登録を行う。<br />
                            5．決済を完了する。<br />
                            6．ご注文確認メールが登録メールアドレスに届く<br />
                            7．店舗または郵送で商品を受け取る。<br />
                        </p>
                    <h2 className="fs-5 fw-bold">レンタルの手続き手順について</h2>
                    <h3 className='fs-6 fw-bold text-info'>古着屋さんの店内で商品を探すとき</h3>
                    <p></p>
                        1．レンタルしたい商品を探す<br />
                        2．商品のタグに付くQRコードをお手持ちのスマートフォンで読み込む<br />
                           ふるぷら公式ECサイトの商品ページに遷移する。<br />
                        3. 商品ページ内の【オーダー】＞＞レンタルを選択する。<br />
                        　 ※デフォルトでは、【購入】となっているため、その文字をタップすると選択できます。<br />
                        4．単発での利用かサブスクでの利用を選択する。<br />
                        　 サブスクで利用する場合は、【サブスクを使用する】にチェックしてください。<br />
                        　 単発レンタルの場合は、【サブスクを使用する】のチェックを外し、レンタル期間を選択してください。<br />
                           ※レンタル期間の選択候補は『期間 - 〇％』と示されていますが、〇％は定価に対してお支払いいただく金額です。<br />
                        5．【店舗で受け取る】にチェックをする。<br />
                        　 デフォルトの設定では、『店舗で受け取る』にチェックがついています。<br />
                        6．住所の登録・決済方法の登録を行う。<br />
                        7．決済を完了する。<br />
                        8．ご注文確認メールが登録メールアドレスに届く<br />
                        9．店員さんから商品を受け取る。<br />
                        10．着用を楽しむ。<br />
                        11．店舗来店または郵送にて商品を返却する。<br />
                            単発レンタルはレンタル終了予定日までの返却をお願いします。<br />
                            返却期限をすぎた場合は、延滞料金がかかります。<br />
                            <br />
                    <h3　className='fs-6 fw-bold text-info'>家でレンタルする商品を探すとき</h3>
                    <p></p>
                        1．ふるぷらのECサイトで、レンタルしたい商品を探す<br />
                        2. 商品ページ内の【オーダー】＞＞レンタルを選択する。<br />
                        　 ※デフォルトでは、【購入】となっているため、その文字をタップすると選択できます。<br />
                        3．単発での利用かサブスクでの利用を選択する。<br />
                        　 サブスクで利用する場合は、【サブスクを使用する】にチェックしてください。単発レンタルの場合は、【サブスクを使用する】のチェックを外し、レンタル期間を選択してください。<br />
                           ※レンタル期間の選択候補は『期間 - 〇％』と示されていますが、〇％は定価に対してお支払いいただく金額です。<br />
                        4．受取方法を選択する。<br />
                        　 デフォルトの設定では、『店舗で受け取る』にチェックがついています。郵送での受取を希望する場合は、こちらのチェックを外してください。<br />
                        　※郵送の場合、送料が880円かかります。<br />
                        5．住所の登録・決済方法の登録を行う。<br />
                        6．決済を完了する。<br />
                        7．ご注文確認メールが登録メールアドレスに届く<br />
                        8．店舗または郵送で商品を受け取る。<br />
                        9．着用を楽しむ。<br />
                        10．店舗来店または郵送にて商品を返却する。<br />
                            単発レンタルはレンタル終了予定日までの返却をお願いします。<br />
                            返却期限をすぎた場合は、延滞料金がかかります。<br />
                            <br />
                    <h2 className="fs-5 fw-bold">レンタル開始日と返却予定日について</h2>
                        <p>
                            レンタル開始日：オーダーが確定した日<br />
                            返却予定日：オーダーが確定した日からレンタル期間が経過した日<br />
                            ----例----<br />
                                4月10日午前11時に単発レンタル(3泊4日)のオーダー確定。<br />
                                レンタル開始日：4月10日<br />
                                返却予定日：4月14日<br />
                            ----------<br />
                            ※商品を受け取った日がレンタル開始日ではないことに注意してください。<br />
                        </p>
                </section>
                <section className='howtorental-return'>
                    <Button
                        variant='primary'
                        onClick={() => navigate('/help/guide/catchreturn')}
                    >
                        返却方法・受取方法の詳細についてはこちら
                    </Button>
            
                </section>
            </Col>
        </Row>
    </Container>
    </>
  )
}

export default HowToRental